export const MEDIA_COLOR_SET = {
  sum: "#6E37FA",
  community: "#dd0014",
  news: "#32BBB9",
  club: "#ffb100",
  twitter: "#2765F0",
  blog: "#5528D2",
  etc: "#b21dac",
}

export const POSITIONINGMAP_COLOR_SET = [
  "#6E37FA", "#32BBB9", "#FF9408", "#F40953", "#FA32A0", "#B30095", "#FFD500", "#AAF564", "#50E6AA", "#2765F0"
];

export const CATEGORY_COLOR_SET = {
  "문화": "#6E37FA",
  "IT": "#32BBB9",
  "인물": "#FF9408",
  "경제": "#F40953",
  "정치사회": "#FA32A0",
  "심리": "#B30095",
  "장소": "#FFD500",
  "브랜드": "#AAF564",
  "제품": "#50E6AA",
  "etc": "#2765F0",
  "blank": "#3e484e"
}

export const SENTIMENT_COLOR_SET = {
  "positive": "#AADCFA",
  "negative": "#FF8296",
  // "neutral": "#FFEA69",
  // "mix": "#C8CBD8",
  "neutral": "#C8CBD8",
  "mix": "#FFEA69",
}

export const CHANNEL_COLOR_SET = {
  "social": "#4614B4",
  "blog0": "#5528D2",
  "blog1": "#D13CBD",
  "blog2": "#DB64C7",
  "blog3": "#E694D9",
  "club0": "#6E37FA",
  "club1": "#8FEFC8",
  "club2": "#C1F6DC",
  "board0": "#9682FF",
  "prof0": "#BEB4FF",
  "kin0": "#DCD2FF",
  "sns0": "#EAE4FF",
  "twit1": "#64BEF0",
  "facebook1": "#AADCFA",
  "insta1": "#DCF0FF",
  "news": "#005F81",
  "pnews0": "#007396",
  "tnews0": "#00889B",
  "inews0": "#009DA8",
  "bnews0": "#88DCDA",
  "enews0": "#C4EDEC",
  "shop": "#C35000",
  "ashop0": "#D75F00",
  "gshop0": "#EB6E00",
  "eshop0": "#FA7D00",
  "cshop0": "#FF9408",
  "wshop0": "#FFBE6A",
  "tshop0": "#FEDEB4",
  "youtube1": "#DCDEE6",
  "video0": "#C8CBD8",
  "renews": "#A00032",
  "kakao1": "#FEE500",
  "custom0": "#BC8F8F",
  "custom10": "#BC8F8F",
  "custom20": "#BC8F8F",
}